import { createD2DChannelPromise, getD2DChannelListPromise } from "../apiPromise/channel";


class d2dProjectConstructor {
  constructor() {
    this.projectInfo = new Map();
  }

  setInfo = (projectId, list) => {
    this.projectInfo.set(projectId, list)
  }

  add = (projectId, info) => {
    let list = this.projectInfo.get(projectId);
    list = [...list, info]
    this.projectInfo.set(projectId, list)
  }

  createChannelPromise = (obj) => {
    const { designId, name, projectId, content } = obj;
    return new Promise((resolve, reject) => {
      createD2DChannelPromise({ designId, name, projectId, content }).then(res => {
        if (res) {
          this.add(projectId, res)
          resolve(res);
        } else {
          resolve(null);
        }
      }, error => {
        console.error(error);
        resolve(null);
      })
    })
  }

  getPromise = (projectId, isNew) => {
    return new Promise((resolve, reject) => {
      const info = this.projectInfo.get(projectId);
      if (info && !isNew) {
        resolve(JSON.parse(JSON.stringify(info)));
      } else {
        getD2DChannelListPromise(projectId).then(res => {
          if (res) {
            this.setInfo(projectId, res)
            resolve(res);
          } else {
            resolve(null);
          }
        }, error => {
          console.error(error);
          resolve(null);
        })
      }
    })
  }

  get = (projectId) => {
    return this.projectInfo.get(projectId)
  }

  delete = (projectId) => {
    this.projectInfo.delete(projectId)
  }

  clearAll = () => {
    this.projectInfo = new Map();
  }
}

let D2DPromiseConstructor = new d2dProjectConstructor();
export default D2DPromiseConstructor;